import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";

const BOOKING_URL = "https://barberianabil.booksy.com/a/";
const PHONE = "+34608865987";
const PHONE2 = "+34948072880";

const LOGO_URL = "https://lh3.googleusercontent.com/pw/AP1GczO2hhUehrKzsAPITSRzzSbLnyPaNInuzu-nU9tccldSnfYRUCnf7qycyCNoNfmRS5IQdH-9fsjAZH4mJNT6uAW1PO5A3nsNA8h17_SFEXcUzliYulI=w400";

const VIDEOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_nabil-cuts/artifacts/y5phi0j6_VID-20260611-WA0036.mp4",
    poster: "https://customer-assets.emergentagent.com/job_nabil-cuts/artifacts/eulxkdfc_IMG-20260611-WA0035.jpg",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_nabil-cuts/artifacts/9ho0rbyo_VID-20260731-WA0007.mp4",
    poster: "",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_nabil-cuts/artifacts/csf1uhq6_VID-20260815-WA0039.mp4",
    poster: "",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_nabil-cuts/artifacts/lg6be783_VID-20260913-WA0012.mp4",
    poster: "",
  },
];

const cutsPhotos = {
  elegante: [
    "https://lh3.googleusercontent.com/pw/AP1GczOiAWzfLP66wrYn-CXw7FleBfgphhv0NRlZcCKpEkwJdBKwkiZJ3zTfMIqd0X1BS_97QurwIPgnZ3O8Ab7w5D3f7t7XqDqOdu-MG5bDYwtdaeee9m0=w1200",
  ],
  nino: [
    "https://lh3.googleusercontent.com/pw/AP1GczOgYS7Ps21ijfJWey7Khi0jj8UeM_mT-RcLTEgD89puWNYbjykxo8qJRKuuXrZ1vZEmBvCD7lgraDHKQoxkjWh7OtMm-xvuUxo1Ny9AefvV4n5Pn2o=w1200",
    "https://lh3.googleusercontent.com/pw/AP1GczO3IwBe2VNRwMz2eaiIsdWV4XbBpnGterGYuDNTk7kt1sgRUDNhp-gv11QCXpI-dTLaKf_6wQ4NTUsIqlXuECJb8i7fecj3SSdWmWYqIKqOTf6a3og=w1200",
  ],
  degradado: [
    "https://lh3.googleusercontent.com/pw/AP1GczNojtX1Nk41AHlKfsZRU6d7OzIRFYRkGsyJlP_UGUT-wwnW3Rxtl1rJU9vhx8SW1jMed8ollYeNwFkQ5snrzxloIsY_zleDTggLNRjCk3ynJWiEI9A=w1200",
    "https://lh3.googleusercontent.com/pw/AP1GczOffmVGXwLBYA9soyJbSFCWbZxWwhC0g3V4VAFhcvJG8OVZApn7PQcPWJmyyJaRX-yf4w9yiNYO6nIhtbC2krV-nUnpeSDMQQUoTj-fd2uB-oN7wec=w1200",
  ],
  disenos: [
    "https://lh3.googleusercontent.com/pw/AP1GczOi1CKpVVTAbaB1vQfDxMYKYSIJeEMNtBiWGwWsyxpQ-te-htMrHKA4ARxDV0d4ChBdfZ83pymWtsSlD7fWVM3pPgjCYru1ngJH6MRar7Nco0n_7Ak=w1200",
    "https://lh3.googleusercontent.com/pw/AP1GczNBPJ7uvPD7zGLkc6dS5uFkI-E1QuN6ZrYxEgIU6SrXyoB_bm3ceVvXDFolgs5pmdTw25dFQ_KWmBaJi6xm8aqwNBYbSmRqP1PXuqGv_-SmTgwGiRQ=w1200",
    "https://lh3.googleusercontent.com/pw/AP1GczNUJuy1Yx9G7XjDfj4S7K0YNf5gZ4t5c1oIPs2dQX3ztiSD6SS86PcnuuTFE1o4JBOJvEQduzZWwCkiSMHdtojAnn6jGF-Lew26xN0xjzhhdE43jZU=w1200",
    "https://customer-assets.emergentagent.com/job_nabil-cuts/artifacts/eulxkdfc_IMG-20260611-WA0035.jpg",
  ],
};

const certificatePhotos = [
  "https://lh3.googleusercontent.com/pw/AP1GczPDfZ9v3KEXUb6ealDHKScdmC42V55Ma7djrJSOqrPngO8BE3W5CvmO5aA3Su4Dw2tMcilf2Ko4VnemqhHvTi5exOEkrhvE-rVxDJNlRyRIQSfkT6E=w1600",
  "https://lh3.googleusercontent.com/pw/AP1GczNvZVowcgBAebgnzouqshcQjEMTezaBpEYLMsCScCBei8Drju79VgbxAStnFcrsyHenRN-a5L39Pif08QM3imxFW2uFJwnQDCSHgP1ojDXfZgZ67wo=w1200",
];

const services = [
  { name: "Corte adulto", desc: "Corte clásico o moderno para adultos", price: "12€" },
  { name: "Corte niños", desc: "Cortes para los más pequeños (hasta 9 años)", price: "10€" },
  { name: "Corte jubilados", desc: "Tarifa especial para jubilados", price: "9€" },
  { name: "Recortar barba", desc: "Arreglo y perfilado de barba", price: "7€" },
  { name: "Cortar y lavar", desc: "Lavado con productos premium y corte", price: "15€" },
  { name: "Corte y barba", desc: "Servicio completo: corte + arreglo de barba", price: "18€" },
];

const cutCategories = [
  { key: "elegante", title: "Corte Elegante", desc: "Acabado clásico y refinado.", photos: cutsPhotos.elegante },
  { key: "nino", title: "Corte Niño", desc: "Cortes para los más pequeños.", photos: cutsPhotos.nino },
  { key: "degradado", title: "Degradado", desc: "Transiciones limpias y precisas.", photos: cutsPhotos.degradado },
  { key: "disenos", title: "Diseños", desc: "Líneas y diseños personalizados.", photos: cutsPhotos.disenos },
];

const Nav = () => (
  <nav className="nav" data-testid="main-nav">
    <a href="#top" className="brand" data-testid="brand-link">
      <img src={LOGO_URL} alt="Logo Peluquería Nabil" className="brand-logo" />
      <span className="brand-text">Peluquería Nabil<small>Caballeros · Berriozar</small></span>
    </a>
    <div className="nav-links">
      <a href="#servicios" data-testid="nav-services">Servicios</a>
      <a href="#cortes" data-testid="nav-cuts">Cortes</a>
      <a href="#video" data-testid="nav-video">Vídeo</a>
      <a href="#certificado" data-testid="nav-cert">Certificación</a>
      <a href="#contacto" data-testid="nav-contact">Contacto</a>
    </div>
    <a className="nav-cta" href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-testid="nav-booking-btn">
      Reservar cita
    </a>
  </nav>
);

const Hero = () => (
  <header id="top" className="hero" data-testid="hero">
    <div className="hero-inner">
      <div className="hero-text">
        <span className="eyebrow">Barbería · Berriozar</span>
        <h1>El arte del<br/><em>caballero</em> bien cuidado.</h1>
        <p>En Peluquería Nabil Caballeros combinamos técnica tradicional y estilo moderno. Corte, barba y diseños en el corazón de Berriozar.</p>
        <div className="hero-cta">
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn-primary" data-testid="hero-booking-btn">
            <i className="fa-regular fa-calendar-check"></i> Reservar cita
          </a>
          <a href={`tel:${PHONE}`} className="btn-ghost" data-testid="hero-call-btn">
            <i className="fa-solid fa-phone"></i> Llamar
          </a>
        </div>
        <div className="hero-meta">
          <div><strong>4.5</strong> <small>Google Maps</small></div>
          <div className="dot"></div>
          <div>Berriozar, Navarra</div>
          <div className="dot"></div>
          <div className="open">● Abierto ahora</div>
        </div>
      </div>
      <div className="hero-img" aria-hidden="true">
        <img src={cutsPhotos.elegante[0]} alt="Trabajo de Peluquería Nabil" />
        <div className="hero-card">
          <div className="hc-row"><span>Hoy</span><strong>09:30 – 14:00</strong></div>
          <div className="hc-row"><span></span><strong>16:00 – 20:30</strong></div>
        </div>
      </div>
    </div>
  </header>
);

const Services = () => (
  <section id="servicios" className="section" data-testid="services-section">
    <div className="section-head">
      <span className="eyebrow">Nuestros servicios</span>
      <h2>Cada detalle importa.<br/><em>Cada corte, una obra.</em></h2>
      <p>Desde un clásico corte adulto hasta el servicio completo de corte y barba. Precios claros, sin sorpresas.</p>
    </div>
    <ul className="services-grid">
      {services.map((s) => (
        <li key={s.name} className="service-card" data-testid={`service-${s.name}`}>
          <div className="service-top">
            <h3>{s.name}</h3>
            <span className="price">{s.price}</span>
          </div>
          <p>{s.desc}</p>
        </li>
      ))}
    </ul>
    <div className="section-foot">
      <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn-primary" data-testid="services-booking-btn">
        <i className="fa-regular fa-calendar-check"></i> Reservar cita
      </a>
    </div>
  </section>
);

const Cuts = () => {
  const [active, setActive] = useState("elegante");
  const current = cutCategories.find((c) => c.key === active);
  return (
    <section id="cortes" className="section dark" data-testid="cuts-section">
      <div className="section-head">
        <span className="eyebrow">Nuestros cortes</span>
        <h2>El estudio y <em>nuestro trabajo.</em></h2>
        <p>Explora cada estilo. Elige el que mejor te define.</p>
      </div>

      <div className="tabs" role="tablist">
        {cutCategories.map((c) => (
          <button
            key={c.key}
            role="tab"
            aria-selected={active === c.key}
            className={`tab ${active === c.key ? "active" : ""}`}
            onClick={() => setActive(c.key)}
            data-testid={`tab-${c.key}`}
          >
            {c.title}
          </button>
        ))}
      </div>

      <div className="tab-panel" data-testid={`panel-${active}`}>
        <p className="tab-desc">{current.desc}</p>
        <div className={`cuts-grid count-${current.photos.length}`}>
          {current.photos.map((src, i) => (
            <figure key={i} className="cut-photo" data-testid={`cut-photo-${active}-${i}`}>
              <img src={src} alt={`${current.title} ${i + 1}`} loading="lazy" />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

const Video = () => (
  <section id="video" className="section video-section" data-testid="video-section">
    <div className="section-head">
      <span className="eyebrow">Nuestro trabajo</span>
      <h2>Mira el <em>arte</em> en acción.</h2>
      <p>Un vistazo a la técnica, el detalle y la precisión que ponemos en cada corte.</p>
    </div>
    <div className="video-grid">
      {VIDEOS.map((v, i) => (
        <div key={i} className="video-frame" data-testid={`video-frame-${i}`}>
          <video
            controls
            playsInline
            preload="metadata"
            poster={v.poster || undefined}
            data-testid={`video-player-${i}`}
          >
            <source src={v.src} type="video/mp4" />
            Tu navegador no soporta vídeo HTML5.
          </video>
        </div>
      ))}
    </div>
  </section>
);

const Certificate = () => (
  <section id="certificado" className="section" data-testid="certificate-section">
    <div className="section-head">
      <span className="eyebrow">Certificación profesional</span>
      <h2>Formados por <em>Iván Martínez.</em></h2>
      <p>
        Certificamos que <strong>Peluquería Nabil</strong> ha sido formada con
        el peluquero profesional <strong>Iván Martínez</strong>, asegurando
        técnica, calidad y dedicación en cada servicio.
      </p>
    </div>
    <div className="cert-grid">
      {certificatePhotos.map((src, i) => (
        <figure key={i} className="cert-photo" data-testid={`cert-photo-${i}`}>
          <img src={src} alt={`Certificado Iván Martínez ${i + 1}`} loading="lazy" />
        </figure>
      ))}
    </div>
  </section>
);

const Reviews = () => (
  <section className="section reviews-section" data-testid="reviews-section">
    <div className="section-head">
      <span className="eyebrow">Opiniones</span>
      <h2>4.5 ★ <em>en Google</em></h2>
      <p>La confianza de nuestros clientes es lo más importante.</p>
    </div>
    <div className="reviews-grid">
      <blockquote data-testid="review-1">
        <p>"Nabil es un crack, corte perfecto y trato inmejorable. Mi barbería de confianza en Berriozar."</p>
        <cite>— Javier M.</cite>
      </blockquote>
      <blockquote data-testid="review-2">
        <p>"Ambiente tranquilo y profesional. Salgo siempre como nuevo. Precios justos."</p>
        <cite>— Iván R.</cite>
      </blockquote>
      <blockquote data-testid="review-3">
        <p>"Muy buen corte a tijera y excelente arreglo de barba. Recomendado 100%."</p>
        <cite>— Carlos D.</cite>
      </blockquote>
    </div>
  </section>
);

const Contact = () => (
  <section id="contacto" className="section dark" data-testid="contact-section">
    <div className="section-head">
      <span className="eyebrow">Visítanos</span>
      <h2>Te esperamos en <em>Berriozar.</em></h2>
    </div>
    <div className="contact-grid">
      <div className="contact-block" data-testid="contact-address">
        <h4>Dirección</h4>
        <p>C. Errekerte, 1<br/>31013 Berriozar, Navarra</p>
        <a className="link-arrow" href="https://www.google.com/maps/dir/?api=1&destination=Peluqueria+Nabil+Caballeros+Berriozar" target="_blank" rel="noopener noreferrer" data-testid="contact-directions-link">Cómo llegar →</a>
      </div>
      <div className="contact-block" data-testid="contact-phone">
        <h4>Teléfono</h4>
        <a href={`tel:${PHONE}`}>+34 608 86 59 87</a>
        <br />
        <a href={`tel:${PHONE2}`}>+34 948 07 28 80</a>
      </div>
      <div className="contact-block" data-testid="contact-hours">
        <h4>Horario</h4>
        <ul className="hours">
          <li><span>Lunes</span><span>09:30-14:00 · 16:00-20:30</span></li>
          <li><span>Martes</span><span>09:30-14:00 · 16:00-20:30</span></li>
          <li><span>Miércoles</span><span>09:30-14:00 · 16:00-20:30</span></li>
          <li><span>Jueves</span><span>09:30-14:00 · 16:00-20:30</span></li>
          <li><span>Viernes</span><span>09:30-14:00 · 16:00-20:30</span></li>
          <li><span>Sábado</span><span>09:30-14:00 · 16:00-20:30</span></li>
          <li className="closed"><span>Domingo</span><span>Cerrado</span></li>
        </ul>
      </div>
    </div>
    <div className="contact-cta">
      <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn-primary big" data-testid="contact-booking-btn">
        <i className="fa-regular fa-calendar-check"></i> Reservar cita
      </a>
    </div>
  </section>
);

const FloatingWhats = () => (
  <a
    href={BOOKING_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="floating-book"
    aria-label="Reservar cita"
    data-testid="floating-booking-btn"
  >
    <i className="fa-regular fa-calendar-check"></i>
    <span>Reservar</span>
  </a>
);

const Footer = () => (
  <footer className="footer" data-testid="footer">
    <p>© {new Date().getFullYear()} Peluquería Nabil · Berriozar, Navarra</p>
  </footer>
);

const Home = () => (
  <div className="page">
    <Nav />
    <Hero />
    <Services />
    <Cuts />
    <Video />
    <Certificate />
    <Reviews />
    <Contact />
    <Footer />
    <FloatingWhats />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
